import { styled } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';

export const StyledMarkdownContent = styled(DialogContent)(({ theme }) => ({
  paddingBlockEnd: 0,

  '& .mdxeditor ol': {
    listStylePosition: 'outside',
    marginLeft: '1.5rem',
    paddingLeft: '1rem',
  },

  '& .mdxeditor ul': {
    listStylePosition: 'outside',
    marginLeft: '1.5rem',
    paddingLeft: '1rem',
  },

  '& .mdxeditor ol li': {
    listStyleType: 'list-item',
    display: 'list-item',
    marginBottom: '0.5rem',
  },

  '& .mdxeditor ul li': {
    listStyleType: 'inherit',
    display: 'list-item',
    marginBottom: '0.5rem',
  },

  '& .mdxeditor ul li[role="checkbox"]': {
    display: 'list-item',
    listStyleType: 'none',
  },

  '& .mdxeditor ul li[role="checkbox"]::before': {
    alignSelf: 'anchor-center',
  },

  '& .mdxeditor ul li[role="checkbox"]::after': {
    alignSelf: 'anchor-center',
  },

  '& .mdxeditor a': {
    color: theme.palette.primary.main,
  },
}));
